module.exports = __webpack_public_path__ + "media/images/pc/reports/mv_copy-ecb09b6974acb0a77be3fff87f226f60.png";